import { FieldBase } from "./field-base.model";

export class ShowField extends FieldBase<string> {
  controlType = "show";
}
